import { isHubSpotOrigin } from '../../../utils/isHubSpotOrigin';
import { navigateToUrl } from '../../../utils/navigateToUrl';
import { WIDGET_MESSAGE_ACTIONS } from '../constants/widgetMessageActions';
import { useHelpMessageHandler } from './useHelpMessageHandler';
const redirectToUrl = url => {
  navigateToUrl(url);
};
export const useOpenUrl = () => {
  useHelpMessageHandler((action, payload) => {
    if (action === WIDGET_MESSAGE_ACTIONS.REDIRECT && payload !== null && payload !== void 0 && payload.url && isHubSpotOrigin(payload.url)) {
      redirectToUrl(payload.url);
    }
  });
};